import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import {
  AuthorizedPartner,
  CreateAuthorizedPartnerRequest,
  UpdateAuthorizedPartnerRequest,
} from 'interfaces';

const basePath = `${AXIOS_URLS.admin}/authorized-partners`;

export const adminAuthorizedPartnersService = {
  getAll: (): Promise<AuthorizedPartner[]> =>
    axiosService.get(basePath).then((res) => res.data),

  create: (data: CreateAuthorizedPartnerRequest): Promise<AuthorizedPartner> =>
    axiosService.post(basePath, data).then((res) => res.data),

  update: (
    id: string,
    data: UpdateAuthorizedPartnerRequest
  ): Promise<AuthorizedPartner> =>
    axiosService.put(`${basePath}/${id}`, data).then((res) => res.data),

  remove: (id: string): Promise<void> =>
    axiosService.delete(`${basePath}/${id}`).then((res) => res.data),

  uploadLogo: (id: string, file: File): Promise<AuthorizedPartner> => {
    const formData = new FormData();
    formData.append('logo', file);

    return axiosService
      .post(`${basePath}/${id}/logo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data);
  },

  removeLogo: (id: string): Promise<AuthorizedPartner> =>
    axiosService.delete(`${basePath}/${id}/logo`).then((res) => res.data),
};